import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, throwError } from 'rxjs';
import { catchError, concatMap, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { BaseActionTypes } from '../../actions/base.actions';
import { SpezifikationEntity } from '../../../entities/mdqx/spezifikation.entity';
import { GetSpezifikationenResponse, SpezifikationActionTypes } from '../../actions/mdqx/spezifikation.actions';
import { HttpService } from '../../../services/http.service';
import { DaveActions } from '../../actions/actions';
import { getToken } from '../../selectors/base.selectors';
import { State } from '../../index';

enum ErrorCodes {
    Get = 'Spezifikationen Abrufen fehlgeschlagen',
}

@Injectable()
export class SpezifikationEffects {
    
    get$ = createEffect(() => this.actions$.pipe(
        ofType(SpezifikationActionTypes.GetSpezifikationenRequest),
        map(
            () => `
            {
                spezifikation {
                    ${SpezifikationEntity.GqlFields}
                }
            }`,
        ),
        withLatestFrom(this.store.select(getToken)),
        switchMap(([query, token]) =>
            this.api.graphQl({ query }, { token }).pipe(
                map(res => res && res.spezifikation),
                concatMap(res =>
                    res
                        ? [
                              new GetSpezifikationenResponse(
                                  res.map(
                                      spezifikation =>
                                          new SpezifikationEntity(spezifikation),
                                  ),
                              ),
                          ]
                        : throwError('empty response'),
                ),
                catchError((err, caught) => of(BaseActionTypes.ErrorAction({
                    Payload: {
                        ToasterMessage: ErrorCodes.Get,
                        Err: err,
                        Caught: caught,
                    }
                }))),
            ),
        ),
    ));

    constructor(
        private actions$: Actions<DaveActions>,
        private api: HttpService,
        private store: Store<State>,
    ) {}
}
